module.exports = __webpack_public_path__ + "static/media/galerija_2019 (40).62d6b7c9.jpg";